export default "__VITE_ASSET__kzw3Kopv1hLF2EnYY1oE$g__"